<template>
  <section
    :section="section"
    class="
      $typography/size:large
      layout/margin:top:page:2
      layout/flex:column
      layout/grid:gap:page:2
    "
    >
    <div
      class="
      layout/wrapper
      "
    >
      <p
        class="
        $typography/size:extra-large
        typography

        "
        v-html="pageTitle"
      />
    </div>
    <div
      class="
      layout/wrapper:bleed
      layout/scroll:horizontal
      layout/margin:page:bottom:-1
      layout/padding:bottom:page
      @568/layout/scroll:clear
      @568/layout/padding:bottom:clear
      @568/layout/page:bottom:clear
      "
      >
      <ul
        class="
          @568/layout/grid:3
          @568/layout/width:100%
          layout/inline-flex
          layout/grid:gap:column:page
          layout/padding:left:page
          layout/padding:right:page
          "
          style="
            --picture--max-height: calc(var(--page-width--layout) * 2 / 3);
            --picture--max-width: calc(var(--page-width--layout) - 2 * var(--page-spacing));
            --568--picture--max-height: calc(var(--page-width--layout) * 2 / 3 / 3);
            --568--picture--max-width: 100%;
          "
        >
        <li
          v-for="l in list"
          :key="l.Id"
          >
          <recommendContent
            :data-gtm="dataGtm"
            :image-url="l.ImageUrl"
            :image-caption="l.ImageCaption"
            :title="l.Title"
            :sub-title="l.SubTitle"
            :detail="l.Detail"
            :link="link(l.Id)"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import recommendContent from './recommend_content.vue';

  export default {
    components: { recommendContent },

    props: {
      list: { type: Array, required: true },
      section: { type: String, required: true },
      pageTitle: { type: String, required: true },
      linkBasePath: { type: String, required: true },
      dataGtm: { type: String, required: true },
    },

    methods: {
      link(id) {
        return `${this.linkBasePath}${id}`;
      }
    },
  };
</script>


